<template>
  <div class="paragraph-component">
    <p class="max-w-full text-ellipsis">{{ text }}</p>
  </div>
</template>

<script>
export default {
  name: "ParagraphComponent",
  props: {
    text: {
      type: String,
      required: true,
    },
  },
};
</script>

<style scoped>
/* .paragraph-component {
  font-size: 16px;
  line-height: 1.5;
  color: #333;
} */
</style>